import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

export const useSessionExpiration = () => {
  const [sessionDisplayed, setSessionDisplayed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const lastLoginTime = localStorage.getItem('lastLoginTime');

    if (lastLoginTime) {
      const lastLogin = parseInt(lastLoginTime, 10);
      const currentTime = Date.now();
      const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;

      if (currentTime - lastLogin < sevenDaysInMs) {
        navigate('/tickets');
        return;
      } else {
        localStorage.setItem('sessionExpired', true);
      }
    }

    const isSessionExpired = localStorage.getItem('sessionExpired');

    if (isSessionExpired) {
      setSessionDisplayed(true);
      localStorage.removeItem('sessionExpired');
    }
  }, [navigate]);

  return sessionDisplayed;
};
